
import { Base } from '../base-component';

import './banner-blue-small-item.component.scss';
import { MediaQueryService } from '../../services/media-query.service';

export class BannerBlueSmallItem extends Base {

	w: number;
	h: number;
	ratio: number;
	imageHolder: HTMLElement;
	contentBackground: HTMLElement;

	constructor(element: Element){
		super(element);
		this.w = 1200;
		this.h = 480; // initial height of the image
		this.ratio = this.w / this.h;
	}

	init() {
		this.imageHolder = this.element.querySelector('.hero-banner-item__image-holder') as HTMLElement;
		this.contentBackground = this.element.querySelector('.hero-banner-item__content-background') as HTMLElement;
		setTimeout(this.onResize.bind(this));
	}

	bindEvents() {
		window.addEventListener('resize', this.onResize.bind(this));
	}

	onResize() {

		const ww = window.innerWidth;

		const el = this.element as HTMLElement;
		el.style.opacity = '1';

		if (ww > this.w) {

			const bannerHeight = ww / this.ratio;
			const colWidth = this.w / 12;
			const cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);

			// this.imageHolder.style.height = bannerHeight + 'px';
			this.contentBackground.style.width = cbWidth + 'px';
			this.contentBackground.style.height = bannerHeight + 'px';

		} else {

			this.contentBackground.style.removeProperty('height');

			if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {

				this.contentBackground.style.width = '100%';
				this.imageHolder.style.height = this.imageHolder.querySelector('img').offsetHeight + 'px';

			} else if (MediaQueryService.getMediaQuery() === 'medium') {

				this.imageHolder.style.removeProperty('height');
				const colWidth = ww / 12;
				this.contentBackground.style.width = (5 * colWidth) + 'px';

			} else {

				this.imageHolder.style.removeProperty('height');
				const colWidth = ww / 12;
				this.contentBackground.style.width = (4 * colWidth) + 'px';

			}

		}

	}

}



// WEBPACK FOOTER //
// ./components/banner-blue-small-item/banner-blue-small-item.component.ts